import * as React from 'react';
import classnames from 'classnames';
import ImageWrapper from 'core/components/ImageWrapper';
import { CarouselImageData } from '../../lib/types';

import * as styles from './Carousel.module.scss';

interface CarouselItemProps {
    image: CarouselImageData['image'];
    imageAlt?: string;
    idx: number;
    current: number;
    hasIntersected: boolean;
}

export default function CarouselItem({
    image,
    imageAlt,
    idx,
    current,
    hasIntersected,
}: CarouselItemProps) {
    const offset = idx - current;

    if (image?.file) {
        return (
            <li
                className={classnames(styles.slide, {
                    [styles.active]: current === idx,
                })}
                style={
                    {
                        '--offset': offset,
                    } as React.CSSProperties
                }
            >
                <div className={styles.snapper}>
                    <ImageWrapper
                        alt={imageAlt ?? `carousel image #${idx + 1}`}
                        image={image?.file}
                        className={styles.image}
                        loading={hasIntersected ? 'eager' : 'lazy'}
                    />
                </div>
            </li>
        );
    }

    return null;
}
